<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner">
      <perfect-scrollbar class="scroll-area" :settings="settings">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <menu-item
              v-for="(menu, mainIndex) in menus"
              :key="mainIndex"
              :item="menu"
              :current-path="currentPath"
              :user="user"
            />
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { setUser } from "./menu";
import MenuItem from "./MenuItem.vue";
import Institution from "../../models/Institution";
import { useAuthStore } from "@/store/auth";

export default {
  components: {
    PerfectScrollbar,
    MenuItem,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",

      institution: Institution.query().first(),
    };
  },
  watch: {
    $route(to) {
      this.currentPath = to.name;
    },
  },
  mounted() {
    setUser(this.user);
    var Sidemenu = function() {
      this.$menuItem = $("#sidebar-menu a");
    };
    var $this = Sidemenu;
    $("#sidebar-menu a").on("click", function(e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("#sidebar-menu ul li.submenu a.active")
      .parents("li:last")
      .children("a:first")
      .addClass("active")
      .trigger("click");
  },
  computed: {
    user() {
      return useAuthStore().user;
    },
    currentPath() {
      return this.$route.name;
    },
    isTeacher() {
      return this.user ? this.user.is_teacher : false;
    },
    permissions() {
      return this.user.permissions;
    },
    canShowCoordinationMenu() {
      return (
        !!this.permissions.view_absent_delay ||
        !!this.permissions.view_class_replacement_coordinator
      );
    },
    canShowDatabaseAudit() {
      return [1, 2].includes(Number(this.user?.id));
    },
    attestedOrDeclaration() {
      return this.institution?.changes_certificate_to_declaration
        ? "Declaração"
        : "Atestado";
    },
    recordAeeOrStudyCase() {
      return this.institution?.configurations?.reports
        ?.changes_record_aee_to_study_case?.value
        ? "Estudo de Caso"
        : "Ficha AEE";
    },
    menus() {
      return [
        {
          mainMenu: "Coordenação",
          icon: "fas fa-id-badge",
          submenu: true,
          can_show: this.canShowCoordinationMenu,
          submenuItems: [
            {
              label: "Remanejamento de Aulas",
              icon: "fas fa-calendar-alt",
              submenu: true,
              can_show: true,
              submenuItems: [
                {
                  label: "Reposição de Aulas",
                  can: "view_class_replacement_coordinator",
                  link: "coordination.class-replacement",
                },
                {
                  label: "Realocação de Aulas",
                  can: "view_class_replacement_coordinator",
                  link: "coordination.lesson-reallocation",
                },
              ],
            },
            {
              label: "Evolução de Registros",
              icon: "fas fa-chart-line",
              can: "view_evolution_registries",
              link: "coordination.evolution-register",
              submenu: false,
            },
            {
              label: "Falta/Atraso",
              icon: "fas fa-user-clock",
              can: "view_absent_delay",
              link: "coordination.absent-delay",
              submenu: false,
            },
            {
              label: "Substituição Eventual",
              icon: "fas fa-exchange-alt",
              can: "view_eventual_replacement",
              link: "coordination.eventual-replacement",
              submenu: false,
            },
            {
              label: "Validação",
              icon: "fas fa-thumbs-up",
              submenu: true,
              can_show:
                !!this.permissions.view_validate_lesson_planning ||
                false ||
                !!this.permissions.view_validate_frequency ||
                false ||
                !!this.permissions.view_validate_lesson_planning_aee ||
                false ||
                !!this.permissions.view_validate_service_aee ||
                false ||
                !!this.permissions.view_validate_retroactive_note,
              submenuItems: [
                {
                  link: "coordination.validate-lesson-planning",
                  label: "Plano de Aula",
                  can: "view_validate_lesson_planning",
                },
                {
                  link: "coordination.validate-frequency",
                  label: "Frequência",
                  can: "view_validate_frequency",
                },
                {
                  link: "coordination.validate-lesson-planning-aee",
                  label: "Plano de Aula AEE",
                  can: "view_validate_lesson_planning_aee",
                },
                {
                  link: "coordination.validate-service-aee",
                  label: "Atendimento AEE",
                  can: "view_validate_service_aee",
                },
                {
                  link: "coordination.validate-retroactive-note",
                  label: "Notas Retroativas",
                  can: "view_validate_retroactive_note",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Escola",
          icon: "fas fa-book",
          submenu: true,
          can_show:
            !!this.permissions.view_institution ||
            false ||
            !!this.permissions.view_course ||
            false ||
            !!this.permissions.view_curricular_component ||
            false ||
            !!this.permissions.view_historic_school ||
            false ||
            !!this.permissions.view_bot_service ||
            false ||
            !!this.permissions.view_school ||
            false ||
            !!this.permissions.view_class ||
            false ||
            !!this.permissions.view_school_class ||
            false ||
            !!this.permissions.view_group ||
            false ||
            !!this.permissions.view_student ||
            false ||
            !!this.permissions.view_sequences_enrollment ||
            false ||
            !!this.permissions.view_grade_vacancy ||
            false ||
            !!this.permissions.view_retroactive_note ||
            false,
          submenuItems: [
            {
              label: " Cadastro",
              icon: "fas fa-user-plus",
              submenu: true,
              can_show:
                !!this.permissions.view_institution ||
                false ||
                !!this.permissions.view_school ||
                false ||
                !!this.permissions.view_curricular_component ||
                false ||
                !!this.permissions.view_course ||
                false ||
                !!this.permissions.view_class ||
                false ||
                !!this.permissions.view_school_class ||
                false ||
                !!this.permissions.view_group ||
                false ||
                !!this.permissions.view_student ||
                false ||
                !!this.permissions.view_sequences_enrollment ||
                false ||
                !!this.permissions.view_calendar_year_school ||
                false ||
                !!this.permissions.view_retroactive_note ||
                false,
              submenuItems: [
                {
                  link: "school.register.student",
                  label: "Alunos",
                  can: "view_student",
                },
                {
                  link: "school.register.institution",
                  label: "Instituição",
                  can: "view_institution",
                },
                {
                  link: "school.school",
                  label: "Escolas",
                  can: "view_school",
                },
                {
                  link: "school.register.calendar",
                  label: "Calendários",
                  can: "view_calendar_year_school",
                },
                {
                  link: "school.curricular-components",
                  label: "Componentes Curriculares",
                  can: "view_curricular_component",
                },
                {
                  link: "school.courses",
                  label: "Cursos",
                  can: "view_course",
                },
                {
                  link: "school.register.evaluation-rule",
                  label: "Regra de Avaliação",
                  can: "view_evaluation_rule",
                },
                {
                  link: "school.grade",
                  label: "Séries",
                  can: "view_grade",
                },
                {
                  link: "school.school-grade",
                  label: "Séries da Escola",
                  can: "view_school_grade",
                },
                {
                  link: "school.register.group",
                  label: "Turmas",
                  can: "view_group",
                },
              ],
            },
            {
              label: "Movimentações",
              icon: "fas fa-arrows-alt",
              submenu: true,
              can_show:
                !!this.permissions.view_blocking_notes_absences ||
                false ||
                !!this.permissions.view_registration_group ||
                false ||
                !!this.permissions.add_reenrollment_automatic ||
                false,
              submenuItems: [
                {
                  link: "school.movements.class-registration",
                  label: "Enturmações em Lote",
                  can: "view_registration_group",
                },
                {
                  link: "school.movements.reenrollment-automatic",
                  label: "Rematrícula Automática",
                  can: "add_reenrollment_automatic",
                },
              ],
            },
            {
              label: "Parâmetros",
              icon: "fas fa-asterisk",
              submenu: true,
              can_show:
                !!this.permissions.view_blocking_notes_absences ||
                false ||
                !!this.permissions.view_school_year_block ||
                false,
              submenuItems: [
                {
                  link: "school.params.blocking-notes-absences",
                  label: "Período de Lançamento de Notas e Faltas por etapa",
                  can: "view_blocking_notes_absences",
                },
                {
                  label: "Bloqueio do Ano Letivo",
                  link: "school.params.school-year-block",
                  can: "view_school_year_block",
                },
              ],
            },
            {
              label: " Processos",
              icon: "fas fa-sitemap",
              submenu: true,
              can_show:
                !!this.permissions.view_historic_school ||
                false ||
                !!this.permissions.view_bot_service ||
                false,
              submenuItems: [
                {
                  link: "school.process.historic-school",
                  label: "Históricos Escolares",
                  can: "view_historic_school",
                },
                {
                  link: "school.process.bot-service",
                  label: "Atendimento BOT",
                  can: "view_bot_service",
                },
              ],
            },
            {
              label: "Tipos",
              icon: "fas fa-list",
              submenu: true,
              can_show:
                this.permissions.view_benefit ||
                false ||
                !!this.permissions.view_sequences_enrollment ||
                false ||
                !!this.permissions.view_grade_components ||
                false ||
                !!this.permissions.view_type_abandonments ||
                false ||
                !!this.permissions.view_type_occurrence_disciplinary ||
                false ||
                !!this.permissions.view_type_projects ||
                false ||
                !!this.permissions.view_type_transfer ||
                false ||
                !!this.permissions.view_type_average_formulas ||
                false ||
                !!this.permissions.view_type_rounding_tables ||
                false ||
                !!this.permissions.view_type_dismiss ||
                false ||
                !!this.permissions.view_type_knowledge_area ||
                false ||
                !!this.permissions.view_type_education ||
                false ||
                !!this.permissions.view_type_education_level ||
                false ||
                !!this.permissions.view_type_habilitation ||
                false ||
                !!this.permissions.view_type_regime ||
                false ||
                !!this.permissions.view_module ||
                false ||
                !!this.permissions.view_type_school_location ||
                false ||
                !!this.permissions.view_type_educational_network ||
                false ||
                !!this.permissions.view_type_group ||
                false ||
                !!this.permissions.view_type_infra_building ||
                false ||
                !!this.permissions.view_type_infra_convenient_function ||
                false ||
                !!this.permissions.view_calendar_day_reason ||
                false,
              submenuItems: [
                {
                  label: " Alunos",
                  icon: "fas fa-user-graduate",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_benefit ||
                    false ||
                    !!this.permissions.view_type_projects ||
                    false,
                  submenuItems: [
                    {
                      link: "school.register.type.students.benefits",
                      label: "Benefícios",
                      can: "view_benefit",
                    },
                    {
                      link: "school.register.type.students.projects",
                      label: "Projetos",
                      can: "view_type_projects",
                    },
                  ],
                },
                {
                  label: " Calendários",
                  icon: "far fa-calendar-alt",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_calendar_day_reason || false,
                  submenuItems: [
                    {
                      link: "school.register.type.calendars.calendar-events",
                      label: "Eventos do Calendário",
                      can: "view_calendar_day_reason",
                    },
                  ],
                },
                {
                  label: " Cursos",
                  icon: "fas fa-graduation-cap",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_education ||
                    false ||
                    !!this.permissions.view_type_education_level ||
                    false ||
                    !!this.permissions.view_type_habilitation ||
                    false ||
                    !!this.permissions.view_type_regime ||
                    false,
                  submenuItems: [
                    {
                      link: "school.register.type.courses.education-types",
                      label: "Ensino",
                      can: "view_type_education",
                    },
                    {
                      link: "school.register.type.courses.education-levels",
                      label: "Nivel de Educação",
                      can: "view_type_education_level",
                    },
                    {
                      link: "school.register.type.courses.habilitations",
                      label: "Habilitação",
                      can: "view_type_habilitation",
                    },
                    {
                      link: "school.register.type.courses.regime-types",
                      label: "Regime",
                      can: "view_type_regime",
                    },
                  ],
                },
                {
                  label: " Componentes Curriculares",
                  icon: "fas fa-book",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_dismiss ||
                    false ||
                    !!this.permissions.view_type_knowledge_area ||
                    false,
                  submenuItems: [
                    {
                      link:
                        "school.register.type.curricular-components.dismissals",
                      label: "Dispensas",
                      can: "view_type_dismiss",
                    },
                    {
                      link:
                        "school.register.type.curricular-components.knowledge-areas",
                      label: "Áreas de conhecimento",
                      can: "view_type_knowledge_area",
                    },
                  ],
                },
                {
                  label: " Matrículas",
                  icon: "fas fa-clipboard-list",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_abandonments ||
                    false ||
                    !!this.permissions.view_type_occurrence_disciplinary ||
                    false ||
                    !!this.permissions.view_type_transfer ||
                    false,
                  submenuItems: [
                    {
                      link: "school.register.type.registrations.abandonments",
                      label: "Abandonos",
                      can: "view_type_abandonments",
                    },
                    {
                      link:
                        "school.register.type.registrations.occurrences-disciplinary",
                      label: "Ocorrências Disciplinares",
                      can: "view_type_occurrence_disciplinary",
                    },
                    {
                      link: "school.register.type.registrations.transfers",
                      label: "Transferências",
                      can: "view_type_transfer",
                    },
                  ],
                },
                {
                  label: " Escolas",
                  icon: "fas fa-building",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_module ||
                    false ||
                    !!this.permissions.view_type_school_location ||
                    false ||
                    !!this.permissions.view_type_educational_network ||
                    false,
                  submenuItems: [
                    {
                      link: "school.register.types.schools.modules",
                      label: "Módulos",
                      can: "view_module",
                    },
                    {
                      link: "school.register.types.schools.school-locations",
                      label: "Localizações",
                      can: "view_type_school_location",
                    },
                    {
                      link:
                        "school.register.types.schools.educational-networks",
                      label: "Rede de Ensino",
                      can: "view_type_educational_network",
                    },
                  ],
                },
                {
                  label: " Infraestrutura",
                  icon: "fas fa-university",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_infra_building ||
                    false ||
                    !!this.permissions.view_type_infra_convenient_function ||
                    false,
                  submenuItems: [
                    {
                      link: "school.register.type.infraestructure.buildings",
                      label: "Prédios",
                      can: "view_type_infra_building",
                    },
                    {
                      link: "school.register.type.infraestructure.environments",
                      label: "Ambientes",
                      can: "view_type_infra_convenient_function",
                    },
                  ],
                },
                {
                  label: " Regras de Avaliação",
                  icon: "fas fa-award",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_average_formulas ||
                    false ||
                    !!this.permissions.view_type_rounding_tables ||
                    false,
                  submenuItems: [
                    {
                      link:
                        "school.register.type.evaluation-rules.average-formulas",
                      label: "Fórmulas de Média",
                      can: "view_type_average_formulas",
                    },
                    {
                      link:
                        "school.register.type.evaluation-rules.rounding-tables",
                      label: "Tabelas de Arredondamento",
                      can: "view_type_rounding_tables",
                    },
                  ],
                },
                {
                  label: " Séries",
                  icon: "fas fa-graduation-cap",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_sequences_enrollment ||
                    false ||
                    !!this.permissions.view_grade_components ||
                    false,
                  submenuItems: [
                    {
                      label: "Componentes da Série",
                      can: "view_grade_components",
                      link: "school.register.type.grades.grade-components",
                      submenu: false,
                    },
                    {
                      label: "Sequências de Enturmação",
                      can: "view_sequences_enrollment",
                      link: "school.types.grades.sequences-enrollment",
                      submenu: false,
                    },
                  ],
                },
                {
                  label: " Turmas",
                  icon: "fas fa-users",
                  submenu: true,
                  can_show: !!this.permissions.view_type_group || false,
                  submenuItems: [
                    {
                      label: "Turma",
                      can: "view_type_group",
                      link: "school.register.type.groups.group-types",
                      submenu: false,
                    },
                  ],
                },
              ],
            },
            {
              label: "Ferramentas",
              icon: "fas fa-tools",
              submenu: true,
              can_show:
                !!this.permissions.view_unification_students ||
                !!this.permissions.view_unification_persons,
              submenuItems: [
                {
                  label: " Unificações",
                  icon: "fas fa-handshake",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_unification_students ||
                    !!this.permissions.view_unification_persons,
                  submenuItems: [
                    {
                      label: "Alunos",
                      can: "view_unification_students",
                      link: "school.tools.unification-student.list",
                      submenu: false,
                    },
                    {
                      label: "Pessoas",
                      can: "view_unification_persons",
                      link: "school.tools.unification-person.list",
                      submenu: false,
                    },
                  ],
                },
              ],
            },
            {
              label: "Pré-Matrícula",
              icon: "fas fa-file-alt",
              submenu: true,
              can_show:
                !!this.permissions.view_grade_vacancy ||
                !!this.permissions.view_pre_enrollment,
              submenuItems: [
                {
                  link: "school.pre-enrollment",
                  label: "Pré-matrícula",
                  can: "view_pre_enrollment",
                },
                {
                  label: "Relátorio",
                  icon: "fas fa-file",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_grade_vacancy ||
                    !!this.permissions.view_pre_enrollment,
                  submenuItems: [
                    {
                      label: "Relatório de Vagas Dispon./Reserv.",
                      link: "reports.grade-vacancy",
                      can: "view_grade_vacancy",
                      submenu: false,
                    },
                  ],
                },
                {
                  link: "school.pre-enrollment.enrollment",
                  label: "Matrícula",
                  can: "view_pre_enrollment",
                },
                {
                  label: "Séries Vagas/Anos",
                  can: "view_grade_vacancy",
                  link: "school.pre-enrollment.grade-vacancy",
                  submenu: false,
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Pessoas",
          icon: "fas fa-users",
          submenu: true,
          can_show:
            !!this.permissions.view_natural_person ||
            false ||
            !!this.permissions.view_color_race ||
            false ||
            !!this.permissions.view_person_deficiency ||
            false ||
            !!this.permissions.view_person_religion ||
            false ||
            !!this.permissions.view_city ||
            false ||
            !!this.permissions.view_legal_person ||
            false,
          submenuItems: [
            {
              label: "Endereçamento",
              icon: "fas fa-map",
              submenu: true,
              can_show: !!this.permissions.view_city,
              submenuItems: [
                {
                  label: "Cidades",
                  can: "view_city",
                  link: "people.addressing.cities",
                  submenu: false,
                },
              ],
            },
            {
              label: "Pessoa Física",
              icon: "fas fa-user",
              link: "people.natural-person",
              can: "view_natural_person",
            },
            {
              label: "Pessoa Jurídicas",
              icon: "fas fa-user",
              link: "people.legal-person",
              can: "view_legal_person",
            },
            {
              label: "Tipos",
              icon: "fas fa-list",
              submenu: true,
              can_show:
                !!this.permissions.view_color_race ||
                false ||
                !!this.permissions.view_person_deficiency ||
                false ||
                !!this.permissions.view_person_religion ||
                false,
              submenuItems: [
                {
                  link: "people.color-race",
                  label: "Cor ou Raça",
                  can: "view_color_race",
                },
                {
                  link: "people.deficiency",
                  label: "Deficiência",
                  can: "view_person_deficiency",
                },
                {
                  link: "people.religion",
                  label: "Religião",
                  can: "view_person_religion",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Professores",
          icon: "fas fa-chalkboard-teacher",
          submenu: true,
          can_show: true,
          submenuItems: [
            {
              label: "AEE",
              icon: "fas fa-chalkboard-teacher",
              submenu: true,
              can_show:
                this.permissions.view_lesson_planning_aee ||
                false ||
                this.permissions.view_record_aee ||
                false ||
                this.permissions.view_service_aee ||
                false ||
                this.permissions.view_study_case_aee ||
                false ||
                this.permissions.view_paee ||
                false ||
                this.permissions.view_type_resource ||
                false ||
                this.permissions.view_type_domain_referral ||
                false ||
                this.permissions.view_type_ta_caa ||
                false,
              submenuItems: [
                {
                  link: "teacher.aee.study-case",
                  label: "Estudo de Caso",
                  can: "view_study_case_aee",
                },
                {
                  link: "teacher.aee.paee",
                  label: "Plano de Atendimento (PAEE)",
                  can: "view_paee",
                },
                {
                  link: "teacher.aee.planning",
                  label: "Plano de Aula AEE",
                  can: "view_lesson_planning_aee",
                },
                {
                  link: "teacher.aee.record-aee",
                  label: this.recordAeeOrStudyCase,
                  can: "view_record_aee",
                },
                {
                  link: "teacher.aee.service-aee",
                  label: "Atendimento AEE",
                  can: "view_service_aee",
                },
                {
                  label: "Tipos",
                  icon: "fas fa-list",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_type_resource ||
                    false ||
                    !!this.permissions.view_type_domain_referral ||
                    false ||
                    !!this.permissions.view_type_ta_caa ||
                    false,
                  submenuItems: [
                    {
                      link: "teacher.aee.types.resource",
                      label: "Recursos AEE",
                      can: "view_type_resource",
                    },
                    {
                      link: "teacher.aee.types.referral",
                      label: "Encaminhamentos",
                      can: "view_type_domain_referral",
                    },
                    {
                      link: "teacher.aee.types.ta-caa",
                      label: "TA / CAA",
                      can: "view_type_ta_caa",
                    },
                  ],
                },
              ],
            },
            {
              label: "Atividades",
              icon: "fas fa-pencil-alt",
              can_show:
                this.permissions.view_activity_register ||
                false ||
                this.permissions.view_activity_note ||
                false,
              submenu: true,
              submenuItems: [
                {
                  link: "teacher.activity-register",
                  label: "Atividades da Turma",
                  can: "view_activity_register",
                },
                {
                  link: "teacher.activity-note.create",
                  label: "Nota das Atividades",
                  can: "view_activity_note",
                },
              ],
            },
            {
              label: "Diário de Classe",
              icon: "fas fa-book",
              submenu: true,
              can_show:
                this.permissions.view_frequency ||
                false ||
                this.permissions.view_notes ||
                false ||
                this.permissions.view_class_replacement ||
                false ||
                this.permissions.view_class_map ||
                false,
              submenuItems: [
                {
                  link: "teacher.frequencies",
                  label: "Frequência",
                  can: "view_frequency",
                },
                {
                  link: "teacher.frequencies.class-map",
                  label: "Mapa de Aulas",
                  can: "view_class_map",
                },
                {
                  link: "teacher.notes",
                  label: "Notas",
                  can: "view_note",
                },
                {
                  link: "teacher.class-replacement",
                  label: "Solicitar Reposição",
                  can: "view_class_replacement",
                },
              ],
            },
            {
              label: "Ocorrência",
              icon: "fas fa-exclamation-triangle",
              link: "teacher.registration.occurrence.disciplinary",
              can: "view_occurrence",
              submenu: false,
            },
            {
              label: "Plano de Aula",
              icon: "fas fa-chalkboard",
              link: "teacher.planning",
              can: "view_lesson_planning",
              submenu: false,
            },
            {
              label: "Avaliações com I.A",
              icon: "fas fa-robot",
              link: "ai.content-generator",
              can: "view_ai_content_generation",
              submenu: false,
              new_tab: true,
            },
            {
              label: "Relatório",
              icon: "fas fa-file",
              submenu: true,
              can_show: !!this.permissions.view_report_service_aee || false,
              submenuItems: [
                {
                  link: "teacher.aee.reports.service-aee",
                  label: "Atendimento AEE",
                  can: "view_report_service_aee",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Servidores",
          icon: "fas fa-users",
          submenu: true,
          can_show:
            !!this.permissions.view_server ||
            false ||
            !!this.permissions.view_time_table ||
            false ||
            !!this.permissions.view_type_category_level ||
            false ||
            !!this.permissions.view_type_role ||
            false ||
            !!this.permissions.view_type_reason_removal ||
            false ||
            !!this.permissions.view_type_schooling ||
            false ||
            !!this.permissions.view_type_employee_bond ||
            false,
          submenuItems: [
            {
              label: "Cadastro",
              icon: "fas fa-user-plus",
              submenu: true,
              can_show: !!this.permissions.view_server || false,
              submenuItems: [
                {
                  link: "servers.function-servers",
                  label: "Servidores",
                  can: "view_server",
                },
              ],
            },
            {
              label: "Relatório",
              icon: "fas fa-file",
              submenu: true,
              can_show: !!this.permissions.view_server || false,
              submenuItems: [
                {
                  link: "servers.teachers-subjects-taught-class",
                  label: "Docentes e disciplinas lecionadas",
                  can: "view_server",
                },
              ],
            },
            {
              label: " Tipos",
              icon: "fas fa-list",
              submenu: true,
              can_show:
                !!this.permissions.view_type_category_level ||
                false ||
                !!this.permissions.view_type_role ||
                false ||
                !!this.permissions.view_type_reason_removal ||
                false ||
                !!this.permissions.view_type_schooling ||
                false ||
                !!this.permissions.view_type_employee_bond ||
                false,
              submenuItems: [
                {
                  link: "servers.register.types.category-levels",
                  label: "Categoria ou Nível",
                  can: "view_type_category_level",
                },
                {
                  link: "servers.register.types.educations",
                  label: "Escolaridade",
                  can: "view_type_schooling",
                },
                {
                  link: "servers.register.types.roles",
                  label: "Funções",
                  can: "view_type_role",
                },
                {
                  link: "servers.register.types.reason-removals",
                  label: "Motivos de Afastamento",
                  can: "view_type_reason_removal",
                },
                {
                  link: "servers.register.types.employee-bonds",
                  label: "Vínculos da Alocação",
                  can: "view_type_employee_bond",
                },
              ],
            },
            {
              label: "Quadro de Horário",
              icon: "fas fa-table",
              link: "servers.time-table",
              can: "view_time_table",
            },
          ],
        },
        {
          mainMenu: "Transporte",
          icon: "fas fa-bus",
          submenu: true,
          can_show:
            !!this.permissions.view_enterprise ||
            false ||
            !!this.permissions.view_driver ||
            false ||
            !!this.permissions.view_point ||
            false ||
            !!this.permissions.view_route ||
            false ||
            !!this.permissions.view_vehicle ||
            false ||
            !!this.permissions.add_person_transport ||
            false,
          submenuItems: [
            {
              label: " Cadastro",
              icon: "fas fa-user-plus",
              submenu: true,
              can_show:
                !!this.permissions.view_enterprise ||
                false ||
                !!this.permissions.view_driver ||
                false ||
                !!this.permissions.view_point ||
                false ||
                !!this.permissions.view_route ||
                false ||
                !!this.permissions.view_vehicle ||
                false,
              submenuItems: [
                {
                  label: "Empresas",
                  link: "school-transport.register.enterprises",
                  can: "view_enterprise",
                },
                {
                  label: "Motoristas",
                  link: "school-transport.register.drivers",
                  can: "view_driver",
                },
                {
                  label: "Veículos",
                  link: "school-transport.register.vehicles",
                  can: "view_vehicle",
                },
                {
                  label: "Pontos",
                  link: "school-transport.register.points",
                  can: "view_point",
                },
                {
                  label: "Rotas",
                  link: "school-transport.register.routes",
                  can: "view_route",
                },
              ],
            },
            {
              label: " Movimentações",
              icon: "fas fa-arrows-alt",
              submenu: true,
              can_show:
                !!this.permissions.add_route ||
                false ||
                !!this.permissions.add_person_transport ||
                false,
              submenuItems: [
                {
                  label: "Cópia de Rotas",
                  link: "school-transport.movements.copy-route",
                  can: "add_route",
                },
                {
                  label: "Usuários de Transporte",
                  link: "school-transport.movements.persons-transports",
                  can: "add_person_transport",
                },
              ],
            },
            {
              label: " Relatórios",
              icon: "fas fa-file",
              submenu: true,
              can_show:
                !!this.permissions.view_report_driver ||
                false ||
                !!this.permissions.view_report_route ||
                false ||
                !!this.permissions.view_report_person_transport ||
                false,
              submenuItems: [
                {
                  label: "Cadastrais",
                  submenu: true,
                  can_show:
                    !!this.permissions.view_report_driver ||
                    false ||
                    !!this.permissions.view_report_route ||
                    false ||
                    !!this.permissions.view_report_person_transport ||
                    false,
                  submenuItems: [
                    {
                      label: "Motoristas",
                      link: "school-transport.reports.registers.drivers",
                      can: "view_report_driver",
                    },
                    {
                      label: "Rotas",
                      link: "school-transport.reports.registers.routes",
                      can: "view_report_route",
                    },
                    {
                      label: "Usuários",
                      link: "school-transport.reports.registers.users",
                      can: "view_report_person_transport",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Alimentação",
          icon: "fas fa-utensils",
          submenu: true,
          can_show:
            !!this.permissions.view_products ||
            false ||
            !!this.permissions.view_unities ||
            false ||
            !!this.permissions.view_snack_menu ||
            false ||
            !!this.permissions.view_menu_class ||
            false,
          submenuItems: [
            {
              label: " Cadastro",
              icon: "fas fa-user-plus",
              submenu: true,
              can_show:
                !!this.permissions.view_products ||
                false ||
                !!this.permissions.view_unities ||
                false,
              submenuItems: [
                {
                  label: "Produtos",
                  link: "school-meals.register.products",
                  can: "view_products",
                },
                {
                  label: "Tipos",
                  can: "view_unities",
                  submenu: true,
                  submenuItems: [
                    {
                      label: "Unidades",
                      link: "school-meals.register.types.unities",
                      can: "view_unities",
                    },
                  ],
                },
              ],
            },
            {
              label: " Gestão",
              icon: "fas fa-cogs",
              submenu: true,
              can_show:
                !!this.permissions.view_snack_menu ||
                false ||
                !!this.permissions.view_menu_class ||
                false,
              submenuItems: [
                {
                  label: "Cardápio",
                  link: "school-meals.management.assemble-menu",
                  can: "view_snack_menu",
                },
                {
                  label: "Cardápio das Turmas",
                  link: "school-meals.management.menu-class",
                  can: "view_menu_class",
                },
              ],
            },
            {
              label: " Consultas",
              icon: "fas fa-search",
              submenu: true,
              can_show: !!this.permissions.view_snack_menu || false,
              submenuItems: [
                {
                  label: "Cardápios Aplicados",
                  link: "school-meals.queries.applied-menus",
                  can: "view_snack_menu",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Configurações",
          icon: "fas fa-cogs",
          submenu: true,
          can_show:
            this.canShowDatabaseAudit ||
            !!this.permissions.view_user_type ||
            false ||
            !!this.permissions.view_chatbot ||
            false ||
            !!this.permissions.view_audit_log ||
            false ||
            !!this.permissions.institution ||
            false ||
            !!this.permissions.view_update_situation_registration_batch ||
            false ||
            !!this.permissions.view_update_registries ||
            false ||
            !!this.permissions.view_bncc ||
            false,
          submenuItems: [
            {
              label: " Auditoria",
              icon: "fas fa-user-shield",
              submenu: true,
              can_show: !!this.permissions.view_audit_log || this.canShowDatabaseAudit,
              submenuItems: [
                {
                  link: "settings.auditing.logs",
                  label: " Log de Notas",
                  can: "view_audit_log",
                },
                {
                  link: "auditing.database",
                  label: " Logs de Alterações",
                  can_show: this.canShowDatabaseAudit,
                },
              ],
            },
            {
              label: " Bncc",
              icon: "fas fa-file-alt",
              submenu: false,
              can: "view_bncc",
              link: "settings.bncc",
            },
            {
              label: " Bot",
              icon: "fas fa-robot",
              submenu: false,
              can: "view_chatbot",
              link: "bot.index",
            },
            {
              label: " Ferramentas de Manutenção",
              icon: "fas fa-wrench",
              submenu: false,
              can:
                "view_update_situation_registration_batch" ||
                "view_update_registries" ||
                "view_update_stages_group" ||
                "view_update_entry_date" ||
                "view_enrollment_maintenance",
              link: "settings.tools-maintenance",
            },
            {
              label: " Parâmetros",
              icon: "fas fa-asterisk",
              link: "settings.params",
              submenu: false,
              can: "view_user_type",
            },
            {
              label: " I.A",
              icon: "fas fa-brain",
              link: "settings.ai",
              submenu: false,
              can: "view_ai_settings",
            },
            {
              label: " Permissões",
              icon: "fas fa-key",
              submenu: true,
              can_show:
                !!this.permissions.view_user_type ||
                false ||
                !!this.permissions.view_settings_users ||
                false,
              submenuItems: [
                {
                  label: " Tipos de Usuário",
                  link: "settings.user-type",
                  submenu: false,
                  can: "view_user_type",
                },
                {
                  label: " Usuários",
                  link: "settings.users",
                  submenu: false,
                  can: "view_settings_users",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Informe Legais",
          icon: "fas fa-balance-scale",
          submenu: true,
          can_show:
            !!this.permissions.view_sagres ||
            false ||
            !!this.permissions.view_educacenso ||
            false ||
            !!this.permissions.import_educacenso ||
            false ||
            !!this.permissions.export_educacenso ||
            false,
          submenuItems: [
            {
              label: "Sagres TCE/SE",
              icon: "fas fa-balance-scale",
              link: "legal-notice.sagres",
              can: "view_sagres",
            },
            {
              label: "Educacenso",
              icon: "fas fa-chart-bar",
              submenu: true,
              can_show:
                !!this.permissions.view_educacenso ||
                false ||
                !!this.permissions.import_educacenso ||
                false ||
                !!this.permissions.export_educacenso ||
                false,
              submenuItems: [
                {
                  label: "Importar",
                  link: "legal-notice.educacenso.import",
                  submenu: false,
                  can: "view_educacenso",
                },
                {
                  label: "Exportar",
                  link: "legal-notice.educacenso.export",
                  submenu: false,
                  can: "export_educacenso",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Documentos",
          icon: "fas fa-folder",
          submenu: true,
          can_show:
            !!this.permissions.view_teacher_bulletin_report ||
            false ||
            !!this.permissions.view_student_bulletin_report ||
            false ||
            !!this.permissions.view_student_record ||
            false ||
            !!this.permissions.view_class_diary_report ||
            false ||
            !!this.permissions.view_calendar_events_report ||
            false ||
            !!this.permissions.view_server_record ||
            false ||
            !!this.permissions.view_report_result_final ||
            false ||
            !!this.permissions.view_report_attested_frequency ||
            false ||
            !!this.permissions.view_report_attested_registration ||
            false ||
            !!this.permissions.view_report_attested_transferency ||
            false ||
            !!this.permissions.view_report_attested_conclusion ||
            false ||
            !!this.permissions.view_report_attested_vacancy ||
            false ||
            !!this.permissions.view_report_conclusion_diplome ||
            false,
          submenuItems: [
            {
              label: "Boletins",
              icon: "fas fa-users-cog",
              can_show:
                !!this.permissions.view_teacher_bulletin_report ||
                false ||
                !!this.permissions.view_student_bulletin_report ||
                false,
              submenu: true,
              submenuItems: [
                {
                  label: "Boletim Escolar",
                  link: "reports.students.bulletin",
                  submenu: false,
                  can: "view_student_bulletin_report",
                },
                {
                  label: "Boletim do Professor",
                  link: "reports.teachers-bulletin",
                  submenu: false,
                  can: "view_teacher_bulletin_report",
                },
              ],
            },
            {
              label: "Diário de Classe",
              icon: "fas fa-users-cog",
              link: "documents.class-diary",
              submenu: false,
              can: "view_class_diary_report",
            },
            {
              label: "Calendários",
              icon: "fas fa-users-cog",
              submenu: true,
              can_show: !!this.permissions.view_calendar_events_report || false,
              submenuItems: [
                {
                  label: "Escolar",
                  link: "documents.calendar.school",
                  can: "view_calendar_events_report",
                },
              ],
            },
            {
              label: "Fichas",
              icon: "fas fa-users-cog",
              can_show:
                !!this.permissions.view_student_record ||
                false ||
                !!this.permissions.view_server_record ||
                false,
              submenu: true,
              submenuItems: [
                {
                  label: "Ficha do Aluno",
                  link: "documents.record-student",
                  submenu: false,
                  can: "view_student_record",
                },
                {
                  label: "Ficha do Servidor",
                  link: "documents.record-server",
                  submenu: false,
                  can: "view_server_record",
                },
              ],
            },
            {
              label: "Resultados",
              icon: "fas fa-users-cog",
              can_show: !!this.permissions.view_report_result_final || false,
              submenu: true,
              submenuItems: [
                {
                  label: "Resultado Final",
                  link: "reports.finalresult",
                  submenu: false,
                  can: "view_report_result_final",
                },
              ],
            },
            {
              label: this.institution?.changes_certificate_to_declaration
                ? "Declarações"
                : "Atestados",
              icon: "fas fa-users-cog",
              can_show:
                !!this.permissions.view_report_attested_frequency ||
                false ||
                !!this.permissions.view_report_attested_registration ||
                false ||
                !!this.permissions.view_report_attested_transferency ||
                false ||
                !!this.permissions.view_report_attested_conclusion ||
                false ||
                !!this.permissions.view_report_attested_vacancy ||
                false ||
                !!this.permissions.view_report_conclusion_diplome ||
                false,
              submenu: true,
              submenuItems: [
                {
                  label: this.attestedOrDeclaration + " de Frequência",
                  link: "documents.attested.attested-frequency",
                  submenu: false,
                  can: "view_report_attested_frequency",
                },
                {
                  label: this.attestedOrDeclaration + " de Matrícula",
                  link: "documents.attested.attested-registration",
                  submenu: false,
                  can: "view_report_attested_registration",
                },
                {
                  label: this.attestedOrDeclaration + " de Transferência",
                  link: "documents.attested.attested-transferency",
                  submenu: false,
                  can: "view_report_attested_transferency",
                },
                {
                  label:
                    this.attestedOrDeclaration + " de Conclusão de Curso/Série",
                  link: "documents.attested.attested-conclusion",
                  submenu: false,
                  can: "view_report_attested_conclusion",
                },
                {
                  label: "Diploma de Conclusão",
                  link: "documents.attested.attested-conclusion-diplome",
                  submenu: false,
                  can: "view_report_conclusion_diplome",
                },
                {
                  label: this.attestedOrDeclaration + " de Vaga",
                  link: "documents.attested.attested-vacancy",
                  submenu: false,
                  can: "view_report_attested_vacancy",
                },
              ],
            },
          ],
        },
        {
          mainMenu: "Relatórios",
          icon: "fas fa-file",
          submenu: true,
          can_show:
            !!this.permissions.view_students_per_class_report ||
            false ||
            !!this.permissions.view_students_per_class_customized_report ||
            !!this.permissions.view_map_performance ||
            false ||
            !!this.permissions.view_report_students_birthday ||
            false ||
            !!this.permissions.view_report_students_per_neighborhood ||
            false ||
            !!this.permissions.view_teacher_time_table_report ||
            false ||
            !!this.permissions.view_report_deficiency ||
            false ||
            !!this.permissions.view_report_servers ||
            false ||
            !!this.permissions.view_report_schools ||
            false ||
            !!this.permissions.view_report_benefits ||
            false ||
            !!this.permissions.view_occurrency_disciplinary ||
            false ||
            !!this.permissions.view_absence_conference_report ||
            false ||
            !!this.permissions.view_absent_delay ||
            false ||
            !!this.permissions.view_report_student_performance ||
            false ||
            !!this.permissions.view_report_student_per_school ||
            false ||
            !!this.permissions.view_report_performance_school_moviment ||
            false ||
            !!this.permissions.view_distortion_age_grade ||
            false ||
            !!this.permissions.view_report_class_average_comparison ||
            false ||
            !!this.permissions.view_report_students_enturms ||
            !!this.permissions.view_report_classes ||
            false,
          submenuItems: [
            {
              label: "Matrículas",
              icon: "fas fa-users-cog",
              can_show: true,
              submenu:
                !!this.permissions.view_students_per_class_report ||
                false ||
                !!this.permissions.view_students_per_class_customized_report ||
                !!this.permissions.view_report_students_not_reenrolled ||
                !!this.permissions.view_map_performance ||
                false ||
                !!this.permissions.view_report_students_birthday ||
                false ||
                !!this.permissions.view_report_students_per_neighborhood ||
                false,

              submenuItems: [
                {
                  label: "Alunos por Turma",
                  link: "reports.students-per-class",
                  submenu: false,
                  can: "view_students_per_class_report",
                },
                {
                  label: "Alunos por Turma Customizado",
                  link: "reports.students-per-class-customized",
                  submenu: false,
                  can: "view_students_per_class_customized_report",
                },
                {
                  label: "Alunos por Enturmação",
                  link: "reports.students-per-integration",
                  submenu: false,
                  can: "view_students_per_class_report",
                },
                {
                  label: "Alunos Não Rematrículados",
                  link: "reports.student-not-reenrolled",
                  submenu: false,
                  can: "view_report_students_not_reenrolled",
                },
                {
                  label: "Mapa de desempenho",
                  link: "reports.map-performance",
                  submenu: false,
                  can: "view_map_performance",
                },
                {
                  label: "Aniversariantes do Mês",
                  link: "reports.birthdays",
                  submenu: false,
                  can: "view_report_students_birthday",
                },
                {
                  label: "Alunos por Bairro",
                  link: "reports.students-per-neighborhood",
                  submenu: false,
                  can: "view_report_students_per_neighborhood",
                },
              ],
            },
            {
              label: "Cadastrais",
              icon: "fas fa-chalkboard-teacher",
              can_show:
                !!this.permissions.view_teacher_time_table_report ||
                false ||
                !!this.permissions.view_report_deficiency ||
                false ||
                !!this.permissions.view_report_servers ||
                false ||
                !!this.permissions.view_report_schools ||
                false ||
                !!this.permissions.view_report_benefits ||
                false ||
                !!this.permissions.view_occurrency_disciplinary ||
                !!this.permissions.view_report_classes ||
                false,
              submenu: true,
              submenuItems: [
                {
                  label: "Quadro de Horários",
                  link: "reports.time-table",
                  submenu: false,
                  can: "view_teacher_time_table_report",
                },
                {
                  label: "Alunos com Deficiência",
                  link: "reports.registers.deficiency",
                  submenu: false,
                  can: "view_report_deficiency",
                },
                {
                  label: "Relatório Cadastral de Servidores",
                  link: "reports.servers",
                  submenu: false,
                  can: "view_report_servers",
                },
                {
                  label: "Relatório Geral de Escolas",
                  link: "reports.school",
                  submenu: false,
                  can: "view_report_schools",
                },
                {
                  label: "Relação Geral de Turmas",
                  link: "reports.classes",
                  submenu: false,
                  can: "view_report_classes",
                },
                {
                  label: "Alunos com Benefícios",
                  link: "reports.registers.benefits",
                  submenu: false,
                  can: "view_report_benefits",
                },
                {
                  label: "Ocorrências Disciplinares",
                  link: "reports.ocurrency-disciplinary",
                  submenu: false,
                  can: "view_occurrency_disciplinary",
                },
              ],
            },
            {
              label: "Lançamentos",
              icon: "fas fa-file",
              submenu: true,
              can_show:
                !!this.permissions.view_absence_conference_report ||
                false ||
                !!this.permissions.view_absent_delay ||
                false,
              submenuItems: [
                {
                  label: "Conferência de faltas",
                  link: "reports.absence-conference",
                  can: "view_absence_conference_report",
                  submenu: false,
                },
                {
                  label: "Faltas/Atrasos",
                  link: "reports.absences-delays",
                  can: "view_absent_delay",
                  submenu: false,
                },
              ],
            },
            {
              label: "Indicadores",
              icon: "fas fa-chart-line",
              submenu: true,
              can_show:
                !!this.permissions.view_report_student_performance ||
                false ||
                !!this.permissions.view_report_student_per_school ||
                false ||
                !!this.permissions.view_report_performance_school_moviment ||
                false ||
                !!this.permissions.view_distortion_age_grade ||
                false ||
                !!this.permissions.view_report_class_average_comparison ||
                false,
              submenuItems: [
                {
                  label: "Desempenho de Alunos",
                  link: "reports.student-performance",
                  can: "view_report_student_performance",
                  submenu: false,
                },
                {
                  label: "Distorção Idade/Série",
                  link: "reports.indicators.distortion-age-grade",
                  can: "view_distortion_age_grade",
                  submenu: false,
                },
                {
                  label: "Quantitativo de Alunos por Escola",
                  link: "reports.student-per-school",
                  can: "view_report_student_per_school",
                  submenu: false,
                },
                {
                  label: "Quantitativo de Rendimento e Movimento Escolar",
                  link: "reports.performance-school-moviment",
                  can: "view_report_performance_school_moviment",
                  submenu: false,
                },
                {
                  label: "Comparativo de Média da Turma",
                  link: "reports.class-average-comparison",
                  can: "view_report_class_average_comparison",
                  submenu: false,
                },
              ],
            },
            {
              label: "Movimentações",
              icon: "fas fa-file",
              submenu: true,
              can_show:
                !!this.permissions.view_report_students_enturms || false,
              submenuItems: [
                {
                  label: "Censo Escolar",
                  link: "reports.student-enturms",
                  can: "view_report_students_enturms",
                  submenu: false,
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
</style>
